import React from 'react';
import { Seo } from '../components/seo/Seo';
import { ASSET_IMAGES_PATH } from '../constants';

// About: headshot + artist statement. Two columns on large screens, stacked below.
export const AboutPage = () => (
    <section className="mx-auto max-w-reading">
        <Seo
            title="About"
            canonicalPath="/about"
            description="Dragan Strukelj (b. 1985, Banja Luka, Bosnia and Herzegovina) — a New York based painter in oil and soft pastel, exploring identity, memory, and cultural transition."
        />
        <div className="mb-6 text-eyebrow uppercase tracking-nav text-tone-800">About</div>
        <h1 className="sr-only">About Dragan Strukelj</h1>

        <div className="grid grid-cols-1 gap-8 lg:grid-cols-[420px_1fr] lg:items-start">
            {/* Left column: portrait shown in full (natural 4:5, no crop), with the artist's quote below. */}
            <div>
                <img
                    src={`${ASSET_IMAGES_PATH}/headshot-2.jpg`}
                    alt="Portrait of the artist Dragan Strukelj"
                    loading="lazy"
                    className="w-full drop-shadow-wall"
                />
                <p className="mt-4 text-meta italic text-tone-900">
                    “An image comes to me — maybe from a dream or something I see — and it takes the form of an emotion.
                    When I start to paint I don’t have an idea where I am going; the emotion leads me.”
                </p>
            </div>

            <div className="flex flex-col gap-3 text-body leading-relaxed text-tone-900 text-justify">
                <p>
                    Dragan Strukelj (b. 1985, Banja Luka, Bosnia and Herzegovina) is a New York based painter working primarily in oil and soft pastel.
                    He studied at the Academy of Arts in Banja Luka before continuing his artistic practice in New York.
                </p>
                <p>
                    His work is shaped by experiences of cultural transition, displacement, and personal history. Drawing from familial narratives,
                    memory, and the body as a site of transformation, Strukelj explores the shifting nature of
                    identity and the ways it is continuously formed and reconstructed.
                </p>

                <h2 className="mt-4 text-meta uppercase tracking-nav text-ink">Artist Statement</h2>

                <p>
                    Dragan Strukelj’s work explores identity as fluid, fragmented, and shaped by personal experience, memory, and cultural transition.
                    Working primarily in oil and soft pastel, he creates psychologically charged spaces where figures emerge, dissolve, and transform,
                    existing between the internal and external self.
                </p>
                <p>
                    Born in Bosnia during a period of social and political upheaval, Strukelj’s understanding of identity has been influenced by
                    experiences of displacement, migration, and changing environments. As a former professional ballroom dancer,
                    his background in movement and performance continues to inform his approach to the human figure. Bodies often appear suspended between
                    states of vulnerability, transformation, and self-negotiation.
                </p>
                <p>
                    Strukelj constructs dreamlike environments populated by fragmented figures, masks, shadows, and recurring symbolic elements.
                    His paintings explore how identity is formed, disrupted, and reconstructed through memory, experience, and inherited narratives.

                </p>
                <p>
                    Across bodies of work including ‘Disassembled Identity’ and ‘Liminal Presence’, Strukelj examines the relationship between the visible
                    self and the internal experiences that remain unseen. Rather than presenting fixed narratives, his paintings create open psychological
                    spaces where transformation, uncertainty, and reflection can unfold.

                </p>
                <p>
                    Through subtle distortions of the figure and the atmosphere of his environments,
                    Strukelj investigates identity not as something fixed, but as something continually evolving.

                </p>
            </div>
        </div>
    </section>
);
